<template>
    <section class="product-section">
        <h2 class="product-section-title">Adapter</h2>
        <AdapterOwl :adapters="adapters" />
    </section>
</template>

<script>
import AdapterOwl from '@/components/AdapterOwl'

export default {
    components: {AdapterOwl},
    props: ['adapters'],
    watch: {
        'adapters': {
            handler() {
                this.owl()
            },
            'immediate': true
        }
    },
    computed: {
        getInfoLength() {
            return Math.max.apply(null, this.adapters.map(v => v.info.length))
        }
    },
    methods: {
        owl(){
            $('.owl-carousel').trigger('destroy.owl.carousel')
            this.$nextTick(function() {
                $('.owl-carousel').owlCarousel({
                    margin:10,
                    nav:true,
                    navText: [
                        'prev',
                        'next'
                    ],
                    responsive:{
                        0:{ items:2 },
                        600:{ items:3 },
                        1000:{ items:5 }
                    }
                })
            })
        }
    }
}
</script>
